export function createQualityProperties_old(qualities) {
  return qualities.map((quality) => ({
    // averageQuantity: {
    //   quantity: quality.averageQuantity?.quantity || null,
    //   volume: quality.averageQuantity?.volume || null,
    // },
    comment: quality.comment || null,
    conditionning: quality.conditionning || null,
    description: quality.description || null,
    destinationCompanyId: quality.destinationCompanyId || null,
    // estimatedLogisticCost: {
    //   quantity: quality.estimatedLogisticCost?.quantity || null,
    //   volume: quality.estimatedLogisticCost?.volume || null,
    //   currency: quality.estimatedLogisticCost?.currency || null,
    // },
    exchangeRate: quality.exchangeRate || null,
    hsCode: quality.hsCode || null,
    impuritiesPercentage: quality.impuritiesPercentage || null,
    incoterm: quality.incoterm || null,
    isHedgingRequired: quality.isHedgingRequired || null,
    logisticMaterial: quality.logisticMaterial || null,
    // maxQuantityToLoad: {
    //   quantity: quality.maxQuantityToLoad?.quantity || null,
    //   volume: quality.maxQuantityToLoad?.volume || null,
    // },
    mqcQuantity: quality.mqcQuantity || null,
    mqcVolume: quality.mqcVolume || null,
    numberOfContainers: quality.numberOfContainers || null,
    parentOperationQualityId: quality.parentOperationQualityId || null,
    pdfDisplayName: quality.pdfDisplayName || null,
    price: {
      quantity: quality.price?.quantity || null,
      volume: quality.price?.volume || null,
      currency: quality.price?.currency || null,
    },
    priceType: quality.priceType || null,
    qualityId: quality.quality?.id || null,
    quantity: {
      quantity: quality.quantity?.quantity || null,
      volume: quality.quantity?.volume || null,
    },
    quantityToleranceRate: quality.quantityToleranceRate || null,
    shippingMark: quality.shippingMark || null,
    shortageAllowedPercentage: quality.shortageAllowedPercentage || null,
    stockpileId: quality.stockpileId || null,
    warehouseQualityId: quality.warehouseQualityId || null,
    indexDifferential: quality.indexDifferential || null,
    indexFormula: quality.indexFormula || null,
    indexFormulaPdfDisplayName: quality.indexFormulaPdfDisplayName || null,
    indexName: quality.indexName || null,
    indexName2: quality.indexName2 || null,
    indexOtherCosts: quality.indexOtherCosts || null,
    indexPeriod: quality.indexPeriod || null,
    indexPeriod2: quality.indexPeriod2 || null,
    indexPriceVolume: quality.indexPriceVolume || null,
    indexQpDays: quality.indexQpDays || null,
    indexQuotationalPeriodTerm: quality.indexQuotationalPeriodTerm || null,
    indexQuotationalPeriodTermEndDate:
      quality.indexQuotationalPeriodTermEndDate || null,
    indexQuotationalPeriodTermStartDate:
      quality.indexQuotationalPeriodTermStartDate || null,
    indexRecovery: quality.indexRecovery || null,
    indexReferenceDateOrPeriod: quality.indexReferenceDateOrPeriod || null,
    indexTiming: quality.indexTiming || null,
    indexTiming2: quality.indexTiming2 || null,
    indexValue: quality.indexValue || null,
    indexValue2: quality.indexValue2 || null,
    indexValuePercentage: quality.indexValuePercentage || null,
    indexValuePercentage2: quality.indexValuePercentage2 || null,
    isIndexValue2Temporary: quality.isIndexValue2Temporary || null,
    // isTemporaryPrice: quality.isTemporaryPrice || null,
    isTemporaryPrice: true,
    priceIndex: quality.priceIndex || null,
  }));
}
export function createQualityProperties(qualities, excelRowrs) {
  return qualities.map((quality) => {
    const newQuality = {
      comment: quality.comment || null,
      conditionning: quality.conditionning || null,
      description: quality.description || null,
      destinationCompanyId: quality.destinationCompanyId || null,
      // estimatedLogisticCost: {
      //   quantity: quality.estimatedLogisticCost?.quantity || null,
      //   volume: quality.estimatedLogisticCost?.volume || null,
      //   currency: quality.estimatedLogisticCost?.currency || null,
      // },
      exchangeRate: quality.exchangeRate || null,
      hsCode: quality.hsCode || null,
      impuritiesPercentage: quality.impuritiesPercentage || null,
      incoterm: quality.incoterm || null,
      isHedgingRequired: quality.isHedgingRequired || null,
      logisticMaterial: quality.logisticMaterial || null,
      mqcQuantity: quality.mqcQuantity || null,
      mqcVolume: quality.mqcVolume || null,
      numberOfContainers: quality.numberOfContainers || null,
      parentOperationQualityId: quality.parentOperationQualityId || null,
      pdfDisplayName: quality.pdfDisplayName || null,
      price: {
        quantity: quality.price?.quantity || null,
        volume: quality.price?.volume || null,
        currency: quality.price?.currency || null,
      },
      priceType: quality.priceType || null,
      qualityId: quality.quality?.id || null,
      quantity: {
        quantity: quality.quantity?.quantity || null,
        volume: quality.quantity?.volume || null,
      },
      quantityToleranceRate: quality.quantityToleranceRate || null,
      shippingMark: quality.shippingMark || null,
      shortageAllowedPercentage: quality.shortageAllowedPercentage || null,
      stockpileId: quality.stockpileId || null,
      warehouseQualityId: quality.warehouseQualityId || null,
      indexDifferential: quality.indexDifferential || null,
      indexFormula: quality.indexFormula || null,
      indexFormulaPdfDisplayName: quality.indexFormulaPdfDisplayName || null,
      indexName: quality.indexName || null,
      indexName2: quality.indexName2 || null,
      indexOtherCosts: quality.indexOtherCosts || null,
      indexPeriod: quality.indexPeriod || null,
      indexPeriod2: quality.indexPeriod2 || null,
      indexPriceVolume: quality.indexPriceVolume || null,
      indexQpDays: quality.indexQpDays || null,
      indexQuotationalPeriodTerm: quality.indexQuotationalPeriodTerm || null,
      indexQuotationalPeriodTermEndDate:
        quality.indexQuotationalPeriodTermEndDate || null,
      indexQuotationalPeriodTermStartDate:
        quality.indexQuotationalPeriodTermStartDate || null,
      indexRecovery: quality.indexRecovery || null,
      indexReferenceDateOrPeriod: quality.indexReferenceDateOrPeriod || null,
      indexTiming: quality.indexTiming || null,
      indexTiming2: quality.indexTiming2 || null,
      indexValue: quality.indexValue || null,
      indexValue2: quality.indexValue2 || null,
      indexValuePercentage: quality.indexValuePercentage || null,
      indexValuePercentage2: quality.indexValuePercentage2 || null,
      isIndexValue2Temporary: quality.isIndexValue2Temporary || null,
      // isTemporaryPrice: quality.isTemporaryPrice || null,
      isTemporaryPrice: true,
      priceIndex: quality.priceIndex || null,
    };

    // if (quality.priceType === 'INDEX' && newQuality.indexValue !== null) {
    //   newQuality.indexValue +=
    //     excelRowrs.find((row) => row.indexName === quality.indexName)
    //       ?.mittelerer || 0;
    // }

    return newQuality;
  });
}
export function createContractValue(rItem, otherRef, qualityProperties,newEndDate) {
  return {
    adminId: rItem.admin?.id || null,
    agent: rItem.agent || null,
    endDate: newEndDate,
    isWM: false,
    marketType: rItem.marketType || null,
    agentCommissionCurrency: rItem.agentCommissionCurrency || null,
    agentCommissionQuantity: rItem.agentCommissionQuantity || null,
    agentCommissionVolume: rItem.agentCommissionVolume || null,
    assignedToId: rItem.assignedToId || null,
    billingEntity: rItem.billingEntity || null,
    comment: rItem.comment || null,
    companyId: rItem.company?.id || null,
    companyReference: rItem.companyReference || null,
    conditionning: rItem.conditionning || null,
    consigneeCompanyIds: rItem.consigneeCompanyIds || null,
    consigneeSiteIds: rItem.consigneeSiteIds || null,
    createdById: rItem.createdById || null,
    dateOfCreation: rItem.dateOfCreation || null,
    division: rItem.division || null,
    exchangeRate: rItem.exchangeRate || null,
    invoiceFollowUpStatus: rItem.invoiceFollowUpStatus || null,
    isPartialShipmentAllowed: rItem.isPartialShipmentAllowed || null,
    isPaymentReceived: rItem.isPaymentReceived || null,
    isTransShipmentAllowed: rItem.isTransShipmentAllowed || null,
    isWarehouse: rItem.isWarehouse || null,
    lastArrivalDate: rItem.lastArrivalDate || null,
    letterOfCreditId: rItem.letterOfCreditId || null,
    maxNumberOfContainers: rItem.maxNumberOfContainers || null,
    minNumberOfContainers: rItem.minNumberOfContainers || null,
    notifyPartyIds: rItem.notifyPartyIds || null,
    origin: rItem.origin || null,
    paymentPercentage: rItem.paymentPercentage || null,
    paymentTerms: rItem.paymentTerms || null,
    photos: rItem.photos || null,
    placeOfDelivery: rItem.placeOfDelivery || null,
    portOfLoading: rItem.portOfLoading || null,
    referenceNumber: otherRef,
    releaseType: rItem.releaseType || null,
    shipmentMode: rItem.shipmentMode || null,
    shouldBeSentToContact: rItem.shouldBeSentToContact || null,
    siteId: rItem.siteId || null,
    status: rItem.status || null,
    subdivision: rItem.subdivision || null,
    type: rItem.type || null,
    qualities: qualityProperties,
  };
}